import { useTranslation } from 'react-i18next'
import { X } from 'lucide-react'
import { LearnerConsultationPanel } from './LearnerConsultationPanel'

interface Props {
  userId: number
  learnerName: string
  onClose: () => void
}

/** 원생 목록에서 여는 상담 기록 모달 — 원생 상세 탭과 같은 패널을 쓴다. */
export function LearnerConsultationModal({ userId, learnerName, onClose }: Props) {
  const { t } = useTranslation(['admin', 'common'])
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40" onClick={onClose}>
      <div
        role="dialog"
        aria-modal="true"
        aria-label={t('admin:students.consultation.modalTitle', { name: learnerName })}
        className="bg-white rounded-xl shadow-xl w-full max-w-3xl max-h-[85vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h2 className="text-lg font-semibold text-gray-900">
            {t('admin:students.consultation.modalTitle', { name: learnerName })}
          </h2>
          <button onClick={onClose} className="p-1 text-gray-400 hover:text-gray-600" aria-label={t('common:button.close')}>
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="px-6 py-4 overflow-y-auto">
          <LearnerConsultationPanel userId={userId} />
        </div>
      </div>
    </div>
  )
}
